<template>
  <div>
    <v-app>
      <v-content>
        <v-container
          fluid
          fill-height
        >
          <v-layout
            align-center
            justify-center
          >
            <v-flex
              xs12
              sm8
              md4
            >
              <v-alert
                type="error"
                :value="error.length > 0"
              >
                {{ error }}
              </v-alert>
              <v-card
                flat
                outlined
              >
                <v-toolbar
                  color="#363636"
                  dark
                  flat
                >
                  <img src="@/assets/HearRo_white_shield_only.svg" />
                  <v-slide-x-transition group leave-absolute>
                    <v-toolbar-title
                      key="login-title"
                      class="ma-3"
                      v-if="componentState === 'Login'"
                    >Login to HearRo</v-toolbar-title>
                    <v-toolbar-title
                      key="create-title"
                      class="ma-3"
                      v-if="componentState === 'Create'"
                    >Create a HearRo Account</v-toolbar-title>
                  </v-slide-x-transition>
                </v-toolbar>
                <v-card-text>
                  <v-form
                    ref="form"
                    v-model="valid"
                  >
                    <v-text-field
                      label="user@email.com"
                      name="email"
                      type="text"
                      :rules="emailRules"
                      required
                      v-model="email"
                      v-on:blur="emailExists"
                    ></v-text-field>
                    <v-slide-x-transition group leave-absolute>
                      <v-text-field
                        key="first-name-field"
                        v-if="( componentState === 'Create' )"
                        label="first name"
                        name="fname"
                        type="text"
                        :rules="nameRules"
                        v-model="firstName"
                      ></v-text-field>
                      <v-text-field
                        key="last-name-field"
                        v-if="( componentState === 'Create' )"
                        label="last name"
                        name="lname"
                        type="text"
                        :rules="nameRules"
                        v-model="lastName"
                      ></v-text-field>
                    </v-slide-x-transition>
                    <v-text-field
                      label="password"
                      name="password"
                      type="password"
                      :rules="passwordRules"
                      v-model="password"
                    >
                    </v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    :loading="loading"
                    :disabled="!valid || loading"
                    v-on:click="connect"
                  >{{ componentState }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const isEmail = require('isemail');

export default {
  name: 'Login',
  data: () => ({
    loading: false,
    componentState: 'Login',
    display: '',
    email: '',
    userId: '',
    firstName: '',
    lastName: '',
    emailRules: [
      v => !!v || 'email required',
      v => isEmail.validate(v) || 'email address invalid'
    ],
    nameRules: [
      v => !!v || 'name required'
    ],
    password: '',
    passwordRules: [v => !!v || 'password required'],
    error: '',
    valid: false
  }),
  mounted () {
    const { user } = this.$store.getters['hearro/loggedInUser']
    if (user.email) {
      this.email = user.email
      this.userId = user.id
    }
  },
  computed: {
    ...mapGetters('hearro', [
      'loggedInUser',
      'userExists'
    ])
  },
  methods: {
    async emailExists () {
      const isValidEmail = isEmail.validate(this.email)

      if (!isValidEmail) { return }
      this.error = ''
      this.loading = true
      try {
        const id = await this.userExists(this.email)
        if (id) {
          this.componentState = 'Login'
          this.userId = id
        } else {
          this.userId = ''
          this.componentState = 'Create'
        }
      } catch (e) {
        console.error(e);
        this.error = e.message
      } finally {
        this.loading = false
      }
    },
    async connect () {
      this.loading = true
      this.error = ''
      if (this.userId) {
        try {
          await this.$store.dispatch('hearro/loginUser', {
            email: this.email,
            password: this.password,
            openWallet: true
          });
          this.$router.push(`/user/${this.loggedInUser.user.id}`);
        } catch (e) {
          this.error = `${e.message}`;
          console.error(e);
        } finally {
          this.loading = false
        }
      } else {
        try {
          await this.$store.dispatch('hearro/createUser', {
            email: this.email,
            password: this.password,
            first: this.firstName,
            last: this.lastName
          });

          await this.$store.dispatch('hearro/loginUser', {
            email: this.email,
            password: this.password,
            openWallet: true
          });

          this.$router.push(`/user/${this.loggedInUser.user.id}`);
        } catch (e) {
          this.error = `${e.message}`;
          console.error(e);
        }
      }
      this.loading = false;
    }
  }
};
</script>
